import { useFormikContext } from 'formik';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';

import { ErrorContainerStyled } from './styled';

const ErrorMessage: React.FC<{ name: string }> = ({ name }) => {
  const formContext = useFormikContext();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!isSubmitting) setIsSubmitting(formContext?.isSubmitting);
  }, [formContext?.isSubmitting, isSubmitting]);

  const errorMessage = get(formContext, ['errors', name]);
  const isTouched = get(formContext, ['touched', name]);

  return (isTouched || isSubmitting) && errorMessage ? (
    <div className='input-error' style={{ marginTop: -8, marginBottom: 12 }}>
      <ErrorContainerStyled>{errorMessage}</ErrorContainerStyled>
    </div>
  ) : null;
};

export default React.memo(ErrorMessage);
